import { Box } from 'components/primitives/box';

const Container = ({ size = 'md', children, whiteBg = false, containerClasses = '', withNav = true }) => (
  <Box
    background={whiteBg ? 'white' : undefined}
    className={`${withNav ? 'NavTop-push u-sm-pb0 u-pv2' : ''}  `}
    style={{ margin: '0 auto' }}
  >
    <div className={`Container Container--${size} ${containerClasses.toString()}`}>{children}</div>
  </Box>
);

export default Container;
